<template>
    <div>
      <template v-if="generatingEvidenceReportPDF">
        <div class="rounded-md bg-yellow-50 p-4">
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3 text-center">
                    <h3 class="text-sm font-medium text-yellow-800">
                       Please wait while generatingEvidenceReportPDF....
                    </h3>
                </div>
            </div>
        </div>
      </template>
      <template v-else>
          <div  class="bg-gray-50 min-h-screen break-all" v-for="(evidence_detail,index) in all_evidence" :key="index" v-if="index == active">
            <div class="bg-indigo-600">
              <div class="container mx-auto px-4 sm:px-6 lg:px-8 pt-4">
                  <div class="lg:flex lg:items-start lg:justify-between">
                      <div class="flex-1 min-w-0 tracking-wide">
                          <h4 class="text-sm font-bold leading-7 text-white">
                            Protest Request Evidence (<a href="javascript:void(0);" @click="AccountInfoModalVisiblity=true">#{{evidence_detail.evidences.protest_request.user_property.account_no}}</a>)
                          </h4>
                          <p class="text-sm font-semibold text-white opacity-90 mt-1 mb-2">Remaining Evidence: {{remainingEvidence}}</p>
                      </div>
  
                      <div class="mt-4 flex-shrink-0 flex flex-wrap lg:mt-0 lg:ml-4 -mr-4">
                          <a v-if="reportPDFPath" :href="reportPDFPath" target="_blank"
                              class="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-xs tracking-wide font-medium text-indigo-700 bg-white hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-600 focus:ring-indigo-50 m-4 ml-0 mt-0">
                              View Report PDF
                          </a>
                          <a  @click="generateEvidenceReportPDF()" class="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-xs tracking-wide font-medium text-indigo-700 bg-white hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-600 focus:ring-indigo-50 m-4 ml-0 mt-0">
                              Generate Report PDF
                          </a>
                          <a v-if="evidenceStatusCheck == 0 || evidenceStatusCheck == 2 || evidenceStatusCheck == 3" @click="openApproveModal()" href="javascript:void(0);"
                              class="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-xs tracking-wide font-medium text-indigo-700 bg-white hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-600 focus:ring-indigo-50 m-4 ml-0 mt-0">
                              Approve
                          </a>
                          <a v-if="evidenceStatusCheck == 0 || evidenceStatusCheck == 1 ||evidenceStatusCheck == 3" @click="openAttentionModal()" href="javascript:void(0);"
                              class="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-xs tracking-wide font-medium text-indigo-700 bg-white hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-600 focus:ring-indigo-50 m-4 ml-0 mt-0">
                              Attention Needed
                          </a>
                          <a v-if="evidenceStatusCheck != 3" @click="openRejectModal()" href="javascript:void(0);"
                              class="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-xs tracking-wide font-medium text-indigo-700 bg-white hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-600 focus:ring-indigo-50 m-4 ml-0 mt-0">
                              Reject
                          </a>
                          <a :href='url' class="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-xs tracking-wide font-medium text-indigo-700 bg-white hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-600 focus:ring-indigo-50 m-4 ml-0 mt-0">
                              Add Evidence
                          </a>
                      </div>
                  </div>
              </div>
            </div>
  
            <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
              <div class="rounded-md bg-green-100 px-4 py-2.5 mb-3" v-if="evidenceStatusCheck == 1">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-green-600 mt-px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <p class="text-sm font-semibold text-green-800">Successfully Approved!</p>
                    <div class="mt-1 text-xs text-green-600">
                      <p class="mb-1 font-medium"><span class="font-medium">Home owner cost of repairs :</span> $ {{ home_owner_cost_of_repairs }} </p>
                      <p class="font-medium text-red-500"><span class="font-medium">Operator rating cost of repair :</span> $ {{ evidenceRatedCalcuatedCostOfRepair }} </p>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="rounded-md bg-yellow-100 px-4 py-2.5 mb-3" v-if="evidenceStatusCheck == 2">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-yellow-600 mt-px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <p class="text-sm font-semibold text-yellow-800">Attention Needed!</p>
                    <div class="mt-1 text-xs text-yellow-700 break-all">
                      <p><span class="font-medium">Reason:</span> "{{reasonForAttentonNeeded}}"</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rounded-md bg-red-100 px-4 py-2.5 mb-3" v-if="evidenceStatusCheck == 3">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-red-600 mt-px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <p class="text-sm font-semibold text-red-800">Rejected!</p>
                    <div class="mt-1 text-xs text-red-700 break-all">
                      <p><span class="font-medium">Reason:</span> "{{reasonForAttentonNeeded}}"</p>
                    </div>
                  </div>
                </div>
              </div>
              <Evidence :single_evidence_detail="evidence_detail" :total_evidence="total_evidence" v-on:move-image-to-next="move" :active="active" v-on:include-image-in-evidnece="includeImage" v-on:exclude-image-in-evidnece="excludeImage" :protest_request_uid="protest_request_uid"></Evidence>
  
            <!-- GO to Next Acccount -->
              <!-- <nav class="mt-3 flex items-center justify-between">
                    <div class="w-0 flex-1 flex">
                        <a href="javascript:void(0)" v-if="activeAccount>0"  class="inline-flex items-center text-gray-600 hover:text-gray-800"  @click="moveToNextAccount(-1)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                        </a>
                        <span v-else class="inline-flex items-center text-gray-300 cursor-not-allowed">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                          </span>
  
                    </div>
                    <div class="w-0 flex-1 flex justify-end">
                        <a href="javascript:void(0)" v-if="activeAccount!=list_of_protest_requests_account.length-1" class="inline-flex items-center text-gray-600 hover:text-gray-800" @click="moveToNextAccount(1)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </a>
                        <span v-else class="inline-flex items-center text-gray-300 cursor-not-allowed">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </span>
                    </div>
                </nav> -->
              <!-- History -->
              <h4 class="text-lg font-semibold text-gray-800 mt-6 mb-3">Activity:</h4>
  
              <div class="bg-white rounded shadow border border-gray-100 overflow-hidden mb-7">
  
                <div>
                    <ul class="divide-y divide-gray-200 px-4 sm:px-5" v-if="protest_request_evidence_update_approval_array.internal_user_activities.length >0">
                      <li class="py-4" v-for="(internal_activity,index) in protest_request_evidence_update_approval_array.internal_user_activities" :key="index">
                        <div class="flex">
                          <div class="flex-1 space-y-1">
                            <div class="flex items-center justify-between">
                              <h3 class="text-sm font-medium text-gray-900 mb-0.5">Admin: {{internal_activity.admins?.name}}</h3>
                              <p class="text-sm text-gray-400">{{internal_activity.created_at}}</p>
                            </div>
                            <p class="text-sm text-gray-600" v-if="internal_activity.comment != null"><span class="font-medium">Comment:</span> {{internal_activity.comment}}</p>
                            <p class="text-sm text-gray-600"><span class="font-medium">Activity:</span> {{internal_activity.activity}}</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                </div>
  
  
              <!-- <EvidencePreviousComment :single_evidence_detail="evidence_detail" v-if="showCommentTab == 1"></EvidencePreviousComment>
                <EvidenceUploadPreviousComment :single_evidence_detail="evidence_detail" v-if="showCommentTab == 2"></EvidenceUploadPreviousComment> -->
  
              </div>
                <div class="mt-6 text-center" v-if="previous_page == 'user-properties'">
                  <a  @click="backToUserPropertiesPage()" href="javascript:void(0);"
                      class="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-xs tracking-wide font-medium text-white bg-indigo-700 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-600 focus:ring-indigo-50 m-4 ml-0 mt-0">
                      Back 
                  </a>
                </div>

                <div class="mt-6 text-center" v-if="previous_page == 'tasks'">
                  <a  @click="backToTasksPage()" href="javascript:void(0);"
                      class="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-xs tracking-wide font-medium text-white bg-indigo-700 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-600 focus:ring-indigo-50 m-4 ml-0 mt-0">
                      Back 
                  </a>
                </div>
            </div>
          </div>
      </template>
  
      <!-- Modal components -->
      <Approve v-if="approveModalVisibility" v-on:close-approve-modal="closeApproveModal" :protest_request_uid="protest_request_uid" :home_owner_cost_of_repairs="home_owner_cost_of_repairs" :cost_of_repair_rating="costOfRepairRatingOperator" :is_modal="false"></Approve>
      <AttentionNeeded v-if="attentionModalVisibility" v-on:close-attention-modal="closeAttentionModal" :protest_request_uid="protest_request_uid"></AttentionNeeded>
      <Reject v-if="rejectModalVisibility" v-on:close-reject-modal="closeRejectModal" :protest_request_uid="protest_request_uid" :is-modal="false"></Reject>
      <AccountInfo v-if="AccountInfoModalVisiblity" v-on:close-account-info-modal="closeAccountInfoModal" :protest_request_uid="protest_request_uid" :protest_request="this.all_evidence[0].evidences.protest_request"></AccountInfo>
    </div>
  </template>
  
  <script>
  import { siteUrl } from '../../config/base';
  import Evidence from './Evidence.vue';
  import Approve from './Approve.vue';
  import AccountInfo from './AccountInfo.vue';
  import AttentionNeeded from './AttentionNeeded.vue';
  import Reject from './Reject.vue';
  import EvidencePreviousComment from './EvidencePreviousComment.vue';
  import EvidenceUploadPreviousComment from './EvidenceUploadPreviousComment.vue';
  import ProtestRequestApi from "../../services/api/AdminProtestRequest";
  
  export default {
  props :["evidence_details","protest_request_uid","protest_request_evidence_update_approval","list_of_protest_requests_account","remaining","photo_addendum_path","home_owner_cost_of_repairs","previous_page"],
    components: {
       Evidence:Evidence,
       AccountInfo:AccountInfo,
       AttentionNeeded:AttentionNeeded,
       Approve:Approve,
       Reject:Reject,
       EvidencePreviousComment:EvidencePreviousComment,
       EvidenceUploadPreviousComment:EvidenceUploadPreviousComment
    },
    data() {
      return {
          all_evidence:[],
          protest_request_evidence_update_approval_array:[],
          total_evidence:null,
          url:'',
          active: 0,
          activeAccount:null,
          approveModalVisibility:false,
          attentionModalVisibility:false,
          rejectModalVisibility:false,
          AccountInfoModalVisiblity:false,
          evidenceStatusCheck:0,
          evidenceRatedCalcuatedCostOfRepair:null,
          costOfRepairRatingOperator:null,
          reasonForAttentonNeeded:'',
          disabledImageCount:null,
          enableImageCount:null,
          showCommentTab:0,
          remainingEvidence:null,
          generatingEvidenceReportPDF:false,
          reportPDFPath: null
      };
    },
  
    created(){
      this.all_evidence = this.evidence_details;
      this.total_evidence = this.evidence_details.length;
      this.protest_request_evidence_update_approval_array = this.protest_request_evidence_update_approval;
      if(this.protest_request_evidence_update_approval_array.evidence_update_approval != null) {
        this.evidenceStatusCheck = this.protest_request_evidence_update_approval_array.evidence_update_approval.approval_status;
        this.evidenceRatedCalcuatedCostOfRepair = this.protest_request_evidence_update_approval_array.evidence_update_approval.rated_calcuated_cost_of_repair;
        this.costOfRepairRatingOperator = this.protest_request_evidence_update_approval_array.evidence_update_approval.cost_of_repair_rating;
      }
      this.url = siteUrl+'/admin/protest-requests/'+this.protest_request_uid+'/evidences/upload';
      this.reasonForAttentonNeeded = this.protest_request_evidence_update_approval_array.evidence_update_approval ? this.protest_request_evidence_update_approval_array.evidence_update_approval.reason : '';
      this.activeAccount = this.list_of_protest_requests_account.indexOf(this.protest_request_uid);
      this.remainingEvidence = this.remaining;
      this.reportPDFPath = this.photo_addendum_path;
    },
    computed:{
  
    },
    methods: {
       move(request) {
          var newIndex = this.active + request.direction;
          if (newIndex > (this.total_evidence-1)) newIndex = 0;
          if(newIndex<0) newIndex = this.total_evidence-1;
          this.active =  newIndex;
      },
      openApproveModal(){
        this.approveModalVisibility = true;
      },
       openAttentionModal(){
        this.attentionModalVisibility = true;
      },
      openRejectModal(){
        this.rejectModalVisibility = true;
      },
      closeApproveModal(request){
        this.approveModalVisibility = false;
        if(request.status_changed == 1){
          if(this.evidenceStatusCheck == 0)  this.remainingEvidence = this.remainingEvidence>0 ? this.remainingEvidence - 1: 0;
          this.evidenceStatusCheck = 1;
          ProtestRequestApi.getInternalUserActivites(
            this.protest_request_uid
          ).then((res) => {
            // console.log(res.data.evidenceUpload);
            this.all_evidence = res.data.evidenceUpload;
            this.protest_request_evidence_update_approval_array = res.data.protestRequest;
            this.evidenceRatedCalcuatedCostOfRepair = this.protest_request_evidence_update_approval_array.evidence_update_approval.rated_calcuated_cost_of_repair;
            this.costOfRepairRatingOperator = this.protest_request_evidence_update_approval_array.evidence_update_approval.cost_of_repair_rating;
          }).catch(function(error) {
            throw new Error(error);
          });
        }
      },
      closeAttentionModal(request){
        this.attentionModalVisibility = false;
        if(request.status_changed == 2){
          if(this.evidenceStatusCheck == 0)  this.remainingEvidence = this.remainingEvidence>0 ? this.remainingEvidence - 1: 0;
          this.evidenceStatusCheck = 2;
          this.reasonForAttentonNeeded = request.comment;
         ProtestRequestApi.getInternalUserActivites(
            this.protest_request_uid
          ).then((res) => {
            this.all_evidence = res.data.evidenceUpload;
            this.protest_request_evidence_update_approval_array = res.data.protestRequest;
            this.evidenceRatedCalcuatedCostOfRepair = this.protest_request_evidence_update_approval_array.evidence_update_approval.rated_calcuated_cost_of_repair;
            this.costOfRepairRatingOperator = this.protest_request_evidence_update_approval_array.evidence_update_approval.cost_of_repair_rating;
          }).catch(function(error) {
            throw new Error(error);
          });
        }
      },
      closeRejectModal(request){
        this.rejectModalVisibility = false;
        if(request.status_changed == 3){
          if(this.evidenceStatusCheck == 0)  this.remainingEvidence = this.remainingEvidence>0 ? this.remainingEvidence - 1: 0;
          this.evidenceStatusCheck = 3;
          this.reasonForAttentonNeeded = request.comment;
         ProtestRequestApi.getInternalUserActivites(
            this.protest_request_uid
          ).then((res) => {
            this.all_evidence = res.data.evidenceUpload;
            this.protest_request_evidence_update_approval_array = res.data.protestRequest;
            this.evidenceRatedCalcuatedCostOfRepair = this.protest_request_evidence_update_approval_array.evidence_update_approval.rated_calcuated_cost_of_repair;
            this.costOfRepairRatingOperator = this.protest_request_evidence_update_approval_array.evidence_update_approval.cost_of_repair_rating;
          }).catch(function(error) {
            throw new Error(error);
          });
        }
      },
      closeAccountInfoModal(request){
        this.AccountInfoModalVisiblity = false;
      },
      generateEvidenceReportPDF(){
        this.generatingEvidenceReportPDF = true;
         ProtestRequestApi.adminGenerateEvidenceReportPDF(
            this.protest_request_uid
          ).then((res) => {
            this.generatingEvidenceReportPDF = false;
            if(res.data.photo_addendum_path){
              this.reportPDFPath = res.data.photo_addendum_path;
              alert("EvidenceReport PDF Generated");
              window.open(this.reportPDFPath, '_blank');
            }else{
              this.reportPDFPath = null;
            }
          }).catch(function(error) {
            alert("Error:"+ error);
            throw new Error(error);
          });
      },
      includeImage(request){
  
           ProtestRequestApi.getInternalUserActivites(
            this.protest_request_uid
          ).then((res) => {
            this.all_evidence = res.data.evidenceUpload;
            this.protest_request_evidence_update_approval_array = res.data.protestRequest;
          }).catch(function(error) {
            throw new Error(error);
          });
      },
      excludeImage(request){
           ProtestRequestApi.getInternalUserActivites(
            this.protest_request_uid
          ).then((res) => {
            this.all_evidence = res.data.evidenceUpload;
            this.protest_request_evidence_update_approval_array = res.data.protestRequest;
          }).catch(function(error) {
            throw new Error(error);
          });
      },
      showComments(value){
        this.showCommentTab = value;
      },
      backToUserPropertiesPage(){
        window.location.href = siteUrl + "/admin/user-properties";
      },
      backToTasksPage(){
        window.location.href = siteUrl + "/admin/tasks";
      },
      moveToNextAccount(moveTo){
        var index_of_protest_request = this.list_of_protest_requests_account.indexOf(this.protest_request_uid);
        var next_account_uid = this.list_of_protest_requests_account[index_of_protest_request+moveTo];
        window.location.href = siteUrl + "/admin/protest-requests/"+next_account_uid+"/evidences/show";
      },
    }
  };
  </script>
  
  <style scoped>
  </style>
  